// src/components/common/ErrorState.tsx
// 統一的錯誤狀態顯示組件，取代各頁面的內聯實作

import React from 'react';
import { AlertCircle } from 'lucide-react';

interface ErrorStateProps {
  /** 錯誤標題（可選，不傳則只顯示 message） */
  title?: string;
  /** 錯誤訊息（必填） */
  message: string;
  /** 重試 callback（傳入則顯示 Retry 按鈕） */
  onRetry?: () => void;
  /** 外層容器的附加 className */
  className?: string;
}

const ErrorState: React.FC<ErrorStateProps> = ({
  title,
  message,
  onRetry,
  className = '',
}) => (
  <div className={`p-4 bg-red-50 border border-red-200 rounded-lg ${className}`}>
    {title ? (
      <>
        <div className="flex items-center text-red-600 mb-2">
          <AlertCircle size={20} className="mr-2 flex-shrink-0" />
          <span className="font-medium">{title}</span>
        </div>
        <p className="text-sm text-red-700">{message}</p>
      </>
    ) : (
      <div className="flex items-center text-red-600">
        <AlertCircle size={20} className="mr-2 flex-shrink-0" />
        <span className="text-sm">{message}</span>
      </div>
    )}
    {onRetry && (
      <button
        onClick={onRetry}
        className="mt-3 btn-accent btn-sm rounded-md"
      >
        Retry
      </button>
    )}
  </div>
);

export default ErrorState;
